import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';

import BankAccountStore from 'js/stores/pages/AdminDashboardPage/BankAccountStore';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';

import List from '../../List';
import Row from '../../List/Row';
import ListItem from '../../List/ListItem';
import ListMessage from '../../List/ListMessage';

import User from '../../Display/User';
import Transaction from './Transaction';
import Verified from './Verified';

@observer
export default class BankAccount extends Component {
  bank_account = BankAccountStore.create({ id: parseInt(this.props['*']) });

  constructor(props) {
    super(props);
    this.bank_account.load();
  }

  render() {
    const bank_account = this.bank_account;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/bank_accounts">Bank accounts</Link>
            {bank_account.bank_account && (
              <>
                <Icon name="chevron-right" />
                <Text>{bank_account.bank_account}</Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={bank_account}>
          <Content background={adminPanelColor}>
            {bank_account.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image logo_type={bank_account.logo_type} logo={bank_account.logo_src} />
                  </Display>

                  <Details>
                    <Label>Created</Label>
                    <div>{bank_account.created_at}</div>

                    <Label>Bank account</Label>
                    <div>{bank_account.bank_account}</div>

                    <Label></Label>
                    <div>
                      <Verified verified={bank_account.is_verified} />
                    </div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <User load={{ bank_account_id: bank_account.id }} title="Owner" />
                  </Row>

                  <Row>
                    <List paginator={bank_account.transactions} title="Transactions" icon="list" controls="more">
                      <div>
                        {bank_account.transactions.transactions.length ? (
                          bank_account.transactions.transactions.map(transaction => (
                            <ListItem key={transaction.id} to={`/admin/transactions/transaction/${transaction.id}`}>
                              <Transaction transaction={transaction} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>No transactions found</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>
                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
